import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CtrlIconComponent } from '@co-3/ctrl-ui/icons';
import {
    LoginCredentialsCollapsibleComponent,
    BillingAddressCollapsibleComponent,
    PageHeaderComponent,
} from '../../components';
import { DeactivateAccountComponent } from 'app/customer-portal/components/deactivate-account/deactivate-account.component';

@Component({
    selector: 'app-customer-account-view',
    templateUrl: './customer-account-view.component.html',
    styleUrl: './customer-account-view.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CtrlIconComponent,
        RouterModule,
        LoginCredentialsCollapsibleComponent,
        BillingAddressCollapsibleComponent,
        PageHeaderComponent,
        DeactivateAccountComponent,
    ],
})
export class CustomerAccountViewComponent {}
